import React from "react";
import styles from "./styles.module.scss";
import GettingStartedProgress from "app/components/GettingStarted/GettingStartedProgress";
import SchedulePostingForm from "./SchedulePostingForm";
import { ScheduleTimelineModel } from "./indexModel";
import ScheduleFilter from "app/components/ScheduledPosts/Filter";
import { cls } from "app/utils";
import ScheduleCalendar from "app/components/ScheduledPosts/Calendar";
import ScheduledPagePostsContainer from "app/components/ScheduledPagePostsContainer";
import { useTranslation } from "react-i18next";
import Navbar from "app/components/Navbar";

const Schedule = () => {
  const { t } = useTranslation();
  const {
    handleSelectCalendar,
    onResetClick,
    selectedCalendarDate,
    onSearchSubmit,
    onSelectFilterLocation,
    data,
    initialTargetId,
    loading,
    onPostDelete,
    onPostUpdate,
    onPost,
    sentryRef,
  } = ScheduleTimelineModel();

  return (
    <div className={cls("schedule-container")}>
      <GettingStartedProgress />
      <Navbar
        label={t("Scheduled Posts")}
        hasSearch={false}
        hasNotifications={false}
      />
      <div className={styles.container}>
        <div className={styles.timeline_wrapper}>
          <div className={styles.timeline_container}>
            <SchedulePostingForm onPost={onPost} />
            <ScheduleFilter
              initialTargetId={initialTargetId}
              onSubmit={onSelectFilterLocation}
              onReset={onResetClick}
              onSearchSubmit={onSearchSubmit}
              onSelectedCalendarDateRemove={handleSelectCalendar}
              selectedCalendarDate={selectedCalendarDate}
            />
            <div className={styles.timeline_posts_content}>
              <ScheduledPagePostsContainer
                displayPostLocations
                onPostDelete={onPostDelete}
                onPostUpdate={onPostUpdate}
                containerRef={sentryRef}
                posts={data}
                pending={loading}
                hideReply
                hideLikes
              />
            </div>
          </div>
          <div
            className={cls(
              styles.scheduled_calendar_container,
              "desktop-only-large schedule-calendar",
            )}
          >
            <ScheduleCalendar
              onChange={handleSelectCalendar}
              scheduledPostsCount={data?.length}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Schedule;
